import { render } from "./page-header.vue?vue&type=template&id=4dd53bc8&scoped=true"
const script = {}

import "./page-header.vue?vue&type=style&index=0&id=4dd53bc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4dd53bc8"

export default script